import { get, postJson } from '../httpClient';

/**
 * Gig Boost Dual Opt-In — member-facing.
 *
 * `status` answers "should this member be offered the wizard for this Live
 * Room, and what should it say"; `decide` records their answer along with the
 * exact wording they were shown.
 */
export const dualOptInAPI = {
  status: listingId => get(`/api/dual-opt-in/${listingId}`),

  decide: (listingId, body) => postJson(`/api/dual-opt-in/${listingId}`, body),
};
